// extracted by mini-css-extract-plugin
export default {"container":"Root_container__-iXCs","container_withHeader":"Root_container_withHeader__GfOof","content":"Root_content__iYtIW"};